import { HD, FULL_HD } from '@bedrock-rdk/constants';

export const logoSize = {
  [HD]: {
    w: 251,
    h: 157,
  },
  [FULL_HD]: {
    w: 382,
    h: 215,
  },
};
